import { render } from "./recommend-param-home.vue?vue&type=template&id=97503a9c&scoped=true"
import script from "./recommend-param-home.vue?vue&type=script&lang=js"
export * from "./recommend-param-home.vue?vue&type=script&lang=js"

import "./recommend-param-home.vue?vue&type=style&index=0&id=97503a9c&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97503a9c"]])

export default __exports__